import { useQuery } from '@apollo/client';
import { useSearchParams } from 'react-router-dom';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import { PaymentContainer } from 'src/components/PaymentContainer/PaymentContainer';
import { PaymentGenericError } from 'src/components/PaymentGenericError/PaymentGenericError';
import { GetCheckoutPaymentPageDocument } from 'src/generated/graphql';
import { validateListingProducts } from 'src/utils/listingProducts';

import { FreeListingContract } from './components/FreeListingContract';

export const FreeListingContractPage = () => {
  const [searchParams] = useSearchParams();
  const listingId = searchParams.get('listingId');

  const { data, error, loading } = useQuery(GetCheckoutPaymentPageDocument);

  if (loading) {
    return (
      <PaymentContainer width="small">
        <CustomLoader />
      </PaymentContainer>
    );
  }

  if (!data || error) {
    return <PaymentGenericError testId="basic-data-fetching-failure-error" />;
  }

  const validatedProducts = validateListingProducts(data.listingProducts);

  if (validatedProducts.kind === 'error') {
    return <PaymentGenericError testId="product-validation-error" />;
  }

  return (
    <PaymentContainer width="small">
      <FreeListingContract
        listingId={listingId}
        freemiumProduct={validatedProducts.singleProducts.freemium}
      />
    </PaymentContainer>
  );
};
